export function calculatePlacement(location) {
    const [x,y] = location;
    return `${y}-${x}`
}